/* eslint-disable jsx-a11y/click-events-have-key-events */
import { map, some, last, indexOf, find, remove, sortBy, get, includes } from 'lodash'
import React, { useState } from 'react'
import { Button, FormInput, FormInputCheckbox, FormInputDate, FormInputSelect, FormInputText, FormInputTextArea } from 'camino-react'

const AddButton = ({ text = 'Add CSI', handleClick = () => {} }) => (
  <Button color="link" onClick={() => handleClick()}>
    <span type="plus" className="lnr lnr-plus" />
    {text}
  </Button>
)

const CSIForm = ({ updateCSIState, csi, userOptions, errors }) => {
  const addCSI = () => {
    csi.push({})

    updateCSIState(csi)
  }

  const removeCSI = (object) => {
    remove(csi, object)

    updateCSIState(csi)
  }

  const updateCSIObject = (object, key, value) => {
    const objectIndex = indexOf(csi, object)
    csi[objectIndex] = Object.assign(object, { [key]: value })

    updateCSIState(csi)
  }

  const checkErrors = (index, field) => (
    includes(get(find(errors, ['index', index]), 'errors'), field) && ['Check this field']
  )

  if (!some(csi)) {
    return (
      <AddButton handleClick={() => addCSI()} />
    )
  }

  const statusOptions = [
    { label: 'Open', value: 'open' },
    { label: 'Closed', value: 'closed' },
    { label: 'On hold', value: 'on_hold' }
  ]

  return (
    <div>
      {map(csi, (csiObject, index) => (
        <div>
          <FormInput label="Description">
            <FormInputTextArea
              value={csiObject.description}
              onValue={value => updateCSIObject(csiObject, 'description', value)}
              errors={checkErrors(index, 'description')}
            />
          </FormInput>
          <FormInput label="Owner">
            <FormInputSelect
              options={sortBy(userOptions, 'label')}
              value={find(userOptions, ['value', csiObject.owner_id])}
              onValue={value => updateCSIObject(csiObject, 'owner_id', value)}
              errors={checkErrors(index, 'owner_id')}
            />
          </FormInput>
          <FormInput label="Due date">
            <FormInputDate
              enableTime
              value={csiObject.due_date}
              onValue={value => updateCSIObject(csiObject, 'due_date', value)}
              errors={checkErrors(index, 'due_date')}
            />
          </FormInput>
          <FormInput label="Added to CloudOps CSI Register?">
            <FormInputCheckbox
              value={csiObject.cloudops_register}
              onValue={value => updateCSIObject(csiObject, 'cloudops_register', value)}
            />
          </FormInput>
          {csiObject.cloudops_register && (
            <FormInput label="CSI Item Number">
              <FormInputText
                value={csiObject.csi_item_number}
                onValue={value => updateCSIObject(csiObject, 'csi_item_number', value)}
                errors={checkErrors(index, 'csi_item_number')}
              />
            </FormInput>
          )}

          <FormInput label="Status">
            <FormInputSelect
              options={sortBy(statusOptions, 'label')}
              value={find(statusOptions, ['value', csiObject.status])}
              onValue={value => updateCSIObject(csiObject, 'status', value)}
            />
          </FormInput>

          <span className="link font-medium my-2" onClick={() => removeCSI(csiObject)}>
            Remove CSI
          </span>
          {last(csi) !== csiObject && (<hr className="my-2" />)}
        </div>
      ))}

      <AddButton handleClick={() => addCSI()} text="Add another CSI" />
    </div>
  )
}

export default CSIForm
